import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    candidateId: Number,
    statusUrl: String
  }

  static targets = ["staCode"]

  connect() {
    this.body = document.querySelector('body');
    this.boundReloadPaymentPage = this.reloadPaymentPage.bind(this);
    this.body.addEventListener("candidate:payment:updated", this.boundReloadPaymentPage);
    this.boundShowStaCode = this.showStaCode.bind(this);
    this.body.addEventListener("payment:sta_code:updated", this.boundShowStaCode);
    this.loadStaCode();
  }

  disconnect() {
    if (this.body && this.boundReloadPaymentPage) {
      this.body.removeEventListener("candidate:payment:updated", this.boundReloadPaymentPage);
    }
    if (this.body && this.boundShowStaCode) {
      this.body.removeEventListener("payment:sta_code:updated", this.boundShowStaCode);
    }
  }

  // Le code NITA est poussé par le serveur (CableReady) dès qu'il est connu :
  // ni rechargement de la page, ni interrogation répétée.
  showStaCode(e) {
    const { candidateId, staCode } = e.detail;
    if (this.candidateIdValue != candidateId || !staCode || !this.hasStaCodeTarget) return;

    this.staCodeTarget.textContent = staCode;
  }

  // Le worker signale que plus aucun paiement n'est en attente : on recharge la page
  // (équivalent d'un F5) plutôt que de la morpher, pour retrouver exactement le rendu
  // normal (panneau, modale de résumé, styles).
  reloadPaymentPage(e) {
    const candidateId = e.detail['candidateId'];
    if (this.candidateIdValue != candidateId || this.reloading) return;

    this.reloading = true;
    window.location.reload();
  }

  // Une seule requête à l'ouverture : couvre le code déjà généré avant l'arrivée
  // sur la page (l'évènement serait alors passé inaperçu).
  async loadStaCode() {
    if (!this.hasStatusUrlValue || !this.hasStaCodeTarget) return;

    const currentCode = this.staCodeTarget.textContent.trim();
    if (currentCode !== "" && currentCode !== "En attente...") return;

    try {
      const response = await fetch(this.statusUrlValue, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) return;

      const paymentData = await response.json();

      if (!paymentData.has_pending_payment || paymentData.provider !== 'nita_online') return;

      if (paymentData.sta_code) {
        this.staCodeTarget.textContent = paymentData.sta_code;
      }
    } catch (error) {
      return;
    }
  }

  
}
